import {
	StoreAsyncItem,
	createReducer,
	createAsyncInitialState,
	checkAsyncAction,
	invalidateStateFromAction,
} from '../../../flux';
import { tenantActionsPack } from '../actions';


export interface ITenantState {
	context: StoreAsyncItem<ClientSessionContext>;
	tenant: StoreAsyncItem<Tenant>;
	tenantAccount: StoreAsyncItem<TenantAccount>;
	tokens: StoreAsyncItem<Array<OAuthAccessToken>>;
}

const initialState = {
	context: createAsyncInitialState<ClientSessionContext>(),
	tenant: createAsyncInitialState<Tenant>(),
	tenantAccount: createAsyncInitialState<TenantAccount>(),
	tokens: createAsyncInitialState<Array<OAuthAccessToken>>([]),
} as ITenantState;

const tenantReducer = createReducer(initialState, {
	[tenantActionsPack.types.FETCH_SESSION_CONTEXT]: (action, state) => {
		return {
			context: checkAsyncAction<ClientSessionContext>(action, state.context),
		};
	},
	[tenantActionsPack.types.FETCH_TENANT_BY_ID]: (action, state) => {
		return {
			tenant: checkAsyncAction<Tenant>(action, state.tenant),
		};
	},
	[tenantActionsPack.types.UPDATE_TENANT]: (action, state) => {
		return {
			tenant: invalidateStateFromAction(action, state.tenant),
		};
	},
	[tenantActionsPack.types.FETCH_TENANT_ACCOUNT]: (action, state) => {
		return {
			tenantAccount: checkAsyncAction<Tenant>(action, state.tenantAccount),
		};
	},
	[tenantActionsPack.types.FETCH_ACCESS_TOKENS]: (action, state) => {
		return {
			tokens: checkAsyncAction<Tenant>(action, state.tokens),
		};
	},
	[tenantActionsPack.types.GENERATE_ACCESS_TOKEN]: (action, state) => {
		return {
			tokens: invalidateStateFromAction(action, state.tokens),
		};
	},
	[tenantActionsPack.types.REVOKE_ACCESS_TOKEN]: (action, state) => {
		return {
			tokens: invalidateStateFromAction(action, state.tokens),
		};
	},
});

export default tenantReducer;
